let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Xnhr")).then(() => parcelRequire('3emE4'));